export default __webpack_public_path__ + "media/pro/download-aacf9f84.svg";